import * as u from './utils';

export default () => {
    const container = document.querySelectorAll('.attachment-archive');
    const controls = document.querySelectorAll('.attachment-controls');
    const galleryItems = document.querySelectorAll('.attachment-archive__item');
    const counter = document.querySelector('.attachment-controls__count');
    const counter2 = document.querySelector('.attachment-controls__download .total');
    const cancel = document.querySelector('.attachment-controls__cancel');
    const download = document.querySelector('.attachment-controls__download');
    const selectedItems = [];
    let isDownloading = false;

    if (!galleryItems.length) {
        return;
    }

    const handleAddRemove = (e) => {
        const target = e.currentTarget.dataset.id;
        if (selectedItems.includes(target)) {
            const index = selectedItems.indexOf(target);
            selectedItems.splice(index, 1);

            u.removeClass(e.currentTarget, 'is-saved');
        } else {
            selectedItems.push(target);

            u.addClass(e.currentTarget, 'is-saved');
        }

        counter.innerHTML = selectedItems.length;
        counter2.innerHTML = selectedItems.length;
    };

    for (const el of galleryItems) {
        el.addEventListener('click', handleAddRemove);
    }

    const deselectAll = () => {
        selectedItems.splice(0, selectedItems.length);
        u.removeClass(galleryItems, 'is-saved');

        counter.innerHTML = selectedItems.length;
        counter2.innerHTML = selectedItems.length;
    };

    cancel.addEventListener('click', deselectAll);

    const handleFailure = (message) => {
        alert(message);

        isDownloading = false;
        u.removeClass(container, 'is-running');
        u.removeClass(controls, 'is-running');
    };

    const handleDownload = () => {
        if (isDownloading) {
            return;
        }

        isDownloading = true;
        u.addClass(container, 'is-running');
        u.addClass(controls, 'is-running');

        const start = new Date().getTime();

        // Build data to send
        const data = new FormData();
        data.append('action', 'gallery_download');
        data.append('security', WP.nonce);
        data.append('attachments', selectedItems);

        // Send the request
        let responseStatus;
        let message;

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                responseStatus = response.status;
                return response.json();
            })

            .then((response) => {
                switch (responseStatus) {
                    case 200:
                    case 201:
                    case 202:
                        if (!response.success) {
                            handleFailure(response.data.message);
                        } else {
                            const end = new Date().getTime();

                            // Star the download once at least 2 seconds has run
                            if (end - start < 2000) {
                                setTimeout(
                                    () => {
                                        window.location = response.data.filename;
                                        isDownloading = false;
                                        u.removeClass(container, 'is-running');
                                        u.removeClass(controls, 'is-running');
                                        deselectAll();
                                    },
                                    2000 - (end - start)
                                );
                            } else {
                                window.location = response.data.filename;
                                isDownloading = false;
                                u.removeClass(container, 'is-running');
                                u.removeClass(controls, 'is-running');
                                deselectAll();
                            }
                        }
                        break;
                    default:
                        message = WP.translate.error;
                        handleFailure(message);
                        break;
                }
            })
            .catch(() => {
                message = WP.translate.error;
                handleFailure(message);
            });
    };

    download.addEventListener('click', handleDownload);
};
